(function () {
  function initKitPdp(root) {
    if (!root || root.dataset.primaveraKitPdpReady === 'true') return;
    root.dataset.primaveraKitPdpReady = 'true';

    const quantityInput = root.querySelector('[data-kit-pdp-qty]');
    const quantityMinus = root.querySelector('[data-kit-pdp-qty-minus]');
    const quantityPlus = root.querySelector('[data-kit-pdp-qty-plus]');
    const components = Array.from(root.querySelectorAll('[data-kit-pdp-component]'));
    const variantInput = root.querySelector('input[name="id"]');
    const priceNode = root.querySelector('.primavera-kit-pdp__price');
    const mainHeroImage = root.querySelector('.primavera-kit-pdp__media > img');
    const submitButton = root.querySelector('[name="add"]');
    const submitLabel = submitButton && submitButton.querySelector('span');
    const variantsScript = root.querySelector('[data-kit-pdp-product-variants]');
    const addText = (submitButton && submitButton.dataset.kitPdpAddLabel) || (submitLabel ? submitLabel.textContent.trim() : 'Aggiungi al carrello');
    const soldOutText = (submitButton && submitButton.dataset.kitPdpSoldOutLabel) || 'Esaurito';
    const selectedOptions = [];
    const stickyVariantSelect = document.querySelector('.sticky-atc-bar select[name="id"]');
    const stickyForm = stickyVariantSelect ? stickyVariantSelect.closest('form') : document.getElementById('product-form-sticky-atc-bar');
    const stickySubmitButton = stickyForm ? stickyForm.querySelector('[name="add"]') : document.querySelector('#product-form-sticky-atc-bar [name="add"]');
    let productVariants = [];
    const initialParams = new URLSearchParams(window.location.search);
    const initialOptions = {};
    let initialQuantity = Number.parseInt(initialParams.get('kit_qty') || '', 10);

    initialParams.forEach((value, key) => {
      const match = key.match(/^kit_option_(\d+)$/);
      if (match && value) initialOptions[Number.parseInt(match[1], 10)] = value;
    });

    if (!Number.isFinite(initialQuantity) || initialQuantity < 1) initialQuantity = null;

    if (variantsScript) {
      try {
        productVariants = JSON.parse(variantsScript.textContent || '[]');
      } catch (error) {
        productVariants = [];
      }
    }

    function normalizeOptionValue(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s*\/\s*/g, ' / ')
        .replace(/\s+/g, ' ');
    }

    function seedSelectedOptionsFromVariant() {
      if (!productVariants.length || !variantInput) return;
      const currentVariant =
        productVariants.find((variant) => String(variant.id) === String(variantInput.value)) ||
        productVariants.find((variant) => variant.available !== false) ||
        productVariants[0];

      if (!currentVariant || !Array.isArray(currentVariant.options)) return;
      currentVariant.options.forEach((value, index) => {
        selectedOptions[index] = value;
      });
    }

    seedSelectedOptionsFromVariant();

    function getQuantity() {
      if (!quantityInput) return 1;
      const value = Number.parseInt(quantityInput.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    function setQuantity(value) {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, value);
      syncStickyQuantity();
    }

    function syncStickyQuantity() {
      if (!stickyForm) return;
      const stickyQuantityInput = stickyForm.querySelector('input[name="quantity"]');
      if (stickyQuantityInput) stickyQuantityInput.value = String(getQuantity());
    }

    function syncStickyProperties() {
      if (!stickyForm) return;
      stickyForm.querySelectorAll('[data-kit-sticky-mirrored-property]').forEach((input) => input.remove());

      root.querySelectorAll('[data-kit-pdp-component-property]').forEach((input) => {
        if (!input.name || !input.value) return;
        const mirroredInput = document.createElement('input');
        mirroredInput.type = 'hidden';
        mirroredInput.name = input.name;
        mirroredInput.value = input.value;
        mirroredInput.dataset.kitStickyMirroredProperty = 'true';
        stickyForm.appendChild(mirroredInput);
      });

      syncStickyQuantity();
    }

    function variantMatches(variant) {
      if (!variant || !Array.isArray(variant.options)) return false;

      return selectedOptions.every((value, index) => {
        if (!value || index >= variant.options.length) return true;
        return normalizeOptionValue(variant.options[index]) === normalizeOptionValue(value);
      });
    }

    function optionValueCandidates(value) {
      const raw = String(value || '').trim();
      const candidates = [normalizeOptionValue(raw)];

      raw.split('/').forEach((part) => {
        const normalizedPart = normalizeOptionValue(part);
        if (normalizedPart && !candidates.includes(normalizedPart)) {
          candidates.push(normalizedPart);
        }
      });

      return candidates.filter(Boolean);
    }

    function getSelectedComponentValues() {
      return components
        .map((component) => {
          const selectedButton = component.querySelector('[data-kit-pdp-component-variant].is-selected');
          if (!selectedButton) return '';
          return selectedButton.dataset.optionValue || selectedButton.dataset.variantTitle || '';
        })
        .filter(Boolean);
    }

    function variantMatchesSelectedComponentValues(variant, values) {
      if (!variant || !Array.isArray(variant.options) || !values.length) return false;

      const optionBuckets = variant.options.map((option) => normalizeOptionValue(option));
      const usedIndexes = new Set();

      return values.every((value) => {
        const candidates = optionValueCandidates(value);
        const matchIndex = optionBuckets.findIndex((option, index) => {
          return !usedIndexes.has(index) && candidates.includes(option);
        });

        if (matchIndex < 0) return false;
        usedIndexes.add(matchIndex);
        return true;
      });
    }

    function updateMainHero(variant) {
      if (!mainHeroImage || !variant || !variant.image) return;

      mainHeroImage.src = variant.image;
      if (variant.imageSrcset) {
        mainHeroImage.srcset = variant.imageSrcset;
      } else {
        mainHeroImage.removeAttribute('srcset');
      }
      if (variant.imageAlt) mainHeroImage.alt = variant.imageAlt;
    }

    function syncStickyVariant(variant) {
      if (!variant) return;
      if (stickyVariantSelect) stickyVariantSelect.value = String(variant.id);
      if (stickySubmitButton) {
        const isAvailable = variant.available !== false;
        stickySubmitButton.disabled = !isAvailable;
        stickySubmitButton.toggleAttribute('disabled', !isAvailable);
        const stickyLabel = stickySubmitButton.querySelector('span');
        if (stickyLabel) stickyLabel.textContent = isAvailable ? (window.FoxThemeStrings && window.FoxThemeStrings.addToCart ? window.FoxThemeStrings.addToCart : addText) : soldOutText;
      }
    }

    function updateDisplayedPrice(currentPrice, comparePrice) {
      if (!priceNode || !currentPrice) return;
      const priceWrapper = priceNode.querySelector('[data-primavera-price]');
      const currentNode = priceNode.querySelector('[data-primavera-current-price]');
      const compareNode = priceNode.querySelector('[data-primavera-compare-price]');

      if (!currentNode) {
        priceNode.textContent = currentPrice;
        return;
      }

      currentNode.textContent = currentPrice;
      const hasCompare = Boolean(comparePrice);
      if (compareNode) {
        compareNode.textContent = comparePrice || '';
        compareNode.hidden = !hasCompare;
      }
      if (priceWrapper) priceWrapper.classList.toggle('is-on-sale', hasCompare);
    }

    function updateBundleVariant() {
      if (!productVariants.length || !variantInput) return null;

      const selectedComponentValues = getSelectedComponentValues();
      const matchedVariant =
        (selectedComponentValues.length &&
          (productVariants.find((variant) => variant.available !== false && variantMatchesSelectedComponentValues(variant, selectedComponentValues)) ||
            productVariants.find((variant) => variantMatchesSelectedComponentValues(variant, selectedComponentValues)))) ||
        productVariants.find((variant) => variant.available !== false && variantMatches(variant)) ||
        productVariants.find(variantMatches);

      if (!matchedVariant) return null;

      variantInput.value = matchedVariant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      syncStickyVariant(matchedVariant);
      syncStickyProperties();
      updateMainHero(matchedVariant);

      updateDisplayedPrice(matchedVariant.price, matchedVariant.comparePrice);

      if (submitButton) {
        const isAvailable = matchedVariant.available !== false;
        submitButton.disabled = !isAvailable;
        submitButton.toggleAttribute('disabled', !isAvailable);
        if (submitLabel) submitLabel.textContent = isAvailable ? addText : soldOutText;
      }

      return matchedVariant;
    }
    function normalizeSiblingUrl(value) {
      if (!value || value === '#') return '';
      const trimmed = String(value).trim();
      if (!trimmed || trimmed === '#') return '';
      if (/^gid:\/\/shopify\//i.test(trimmed)) return '';
      if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('/')) {
        if (/\/products\/\d+\/?(?:[?#].*)?$/i.test(trimmed)) return '';
        return trimmed;
      }
      const handle = trimmed.replace(/^products\//, '').replace(/^\/products\//, '').replace(/^\//, '');
      if (!handle || /^\d+$/.test(handle)) return '';
      return `/products/${handle}`;
    }

    function buildSiblingUrl(targetUrl) {
      const normalizedTarget = normalizeSiblingUrl(targetUrl);
      if (!normalizedTarget) return '';
      const nextUrl = new URL(normalizedTarget, window.location.origin);

      selectedOptions.forEach((value, index) => {
        if (value) nextUrl.searchParams.set(`kit_option_${index}`, value);
      });

      nextUrl.searchParams.set('kit_qty', String(getQuantity()));
      return nextUrl.toString();
    }

    function siblingCandidates(button) {
      return [...new Set([button.dataset.siblingUrl, root.dataset.kitSiblingUrl, button.dataset.siblingHandle].map(normalizeSiblingUrl).filter(Boolean))];
    }

    async function firstReachableSiblingUrl(button) {
      const candidates = siblingCandidates(button);

      for (const candidate of candidates) {
        const url = buildSiblingUrl(candidate);
        if (!url) continue;

        try {
          const response = await fetch(url, { method: 'HEAD', credentials: 'same-origin', redirect: 'follow' });
          if (response.ok || response.status === 405) return url;
        } catch (error) {
          return url;
        }
      }

      return '';
    }

    function bindBundleSwitches() {
      root.querySelectorAll('[data-kit-pdp-bundle-switch]').forEach((button) => {
        button.addEventListener('click', async () => {
          if (button.dataset.kitBundleSwitchLoading === 'true') return;
          button.dataset.kitBundleSwitchLoading = 'true';
          const siblingUrl = await firstReachableSiblingUrl(button);
          button.dataset.kitBundleSwitchLoading = 'false';
          if (!siblingUrl) return;
          window.location.assign(siblingUrl);
        });
      });
    }

    function updateHeroTile(component, button) {
      if (!component || !button || !button.dataset.variantImage) return;

      const componentIndex = component.dataset.componentIndex;
      const heroTile = root.querySelector(`[data-kit-pdp-hero-item][data-component-index="${componentIndex}"]`);
      if (!heroTile) return;

      let image = heroTile.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.className = 'primavera-kit-pdp__media-img';
        image.loading = 'eager';
        image.sizes = '(min-width: 990px) 15vw, 34vw';
        heroTile.textContent = '';
        heroTile.appendChild(image);
      }

      image.src = button.dataset.variantImage;
      if (button.dataset.variantImageSrcset) image.srcset = button.dataset.variantImageSrcset;
      image.alt = button.dataset.variantImageAlt || button.dataset.variantTitle || '';
    }

    if (quantityMinus) quantityMinus.addEventListener('click', () => setQuantity(getQuantity() - 1));
    if (quantityPlus) quantityPlus.addEventListener('click', () => setQuantity(getQuantity() + 1));
    if (quantityInput) quantityInput.addEventListener('change', () => setQuantity(getQuantity()));
    if (initialQuantity) {
      setQuantity(initialQuantity);
    } else {
      syncStickyQuantity();
    }


    components.forEach((component) => {
      const buttons = Array.from(component.querySelectorAll('[data-kit-pdp-component-variant]'));
      const propertyInput = component.querySelector('[data-kit-pdp-component-property]');
      const selectedLabel = component.querySelector('[data-kit-pdp-component-selected]');
      const bagDetailSelect = component.querySelector('[data-kit-pdp-bag-detail]');
      const bagVariantsScript = component.querySelector('[data-kit-pdp-bag-variants]');
      let bagVariants = [];

      if (bagVariantsScript) {
        try {
          bagVariants = JSON.parse(bagVariantsScript.textContent || '[]');
        } catch (error) {
          bagVariants = [];
        }
      }

      function applyBagDetail(detail) {
        if (!bagVariants.length) return;
        const selectedDetail = detail || (bagDetailSelect && bagDetailSelect.value) || '';

        buttons.forEach((button) => {
          const color = button.dataset.kitPdpBagColor;
          if (!color) return;
          const matchedVariant =
            bagVariants.find((variant) => String(variant.color) === String(color) && (!selectedDetail || String(variant.detail) === String(selectedDetail))) ||
            bagVariants.find((variant) => String(variant.color) === String(color));

          if (!matchedVariant) return;
          button.dataset.optionValue = matchedVariant.optionValue || matchedVariant.title || '';
          button.dataset.variantTitle = matchedVariant.title || '';
          button.dataset.variantId = matchedVariant.id || '';
          button.dataset.variantImage = matchedVariant.image || '';
          button.dataset.variantImageSrcset = matchedVariant.imageSrcset || '';
          button.dataset.variantImageAlt = matchedVariant.imageAlt || matchedVariant.title || '';
          button.dataset.variantAvailable = String(matchedVariant.available !== false);
          button.classList.toggle('is-sold-out', matchedVariant.available === false);
          if (matchedVariant.title) button.title = matchedVariant.title;
        });
      }

      if (bagDetailSelect && bagVariants.length) applyBagDetail(bagDetailSelect.value);

      function selectVariant(button) {
        if (!button) return;

        buttons.forEach((item) => {
          const isSelected = item === button;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        if (propertyInput) propertyInput.value = button.dataset.variantTitle || '';
        if (selectedLabel) selectedLabel.textContent = button.dataset.variantTitle || '';
        syncStickyProperties();
        updateHeroTile(component, button);

        const optionIndex = Number.parseInt(button.dataset.optionIndex || '', 10);
        if (Number.isFinite(optionIndex)) {
          selectedOptions[optionIndex] = button.dataset.optionValue || button.dataset.variantTitle || '';
        }

        updateBundleVariant();
      }
      let requestedButton = null;
      if (buttons.length) {
        const initialButtonOptionIndex = Number.parseInt(buttons[0].dataset.optionIndex || '', 10);
        const requestedValue = Number.isFinite(initialButtonOptionIndex) ? initialOptions[initialButtonOptionIndex] : '';
        if (requestedValue) {
          requestedButton = buttons.find((button) => {
            return button.dataset.optionValue === requestedValue || button.dataset.variantTitle === requestedValue;
          });
        }
      }

      const selected = requestedButton || component.querySelector('[data-kit-pdp-component-variant].is-selected') || buttons[0];
      if (selected) selectVariant(selected);

      buttons.forEach((button) => {
        button.addEventListener('click', () => selectVariant(button));
      });

      if (bagDetailSelect && bagVariants.length) {
        bagDetailSelect.addEventListener('change', () => {
          applyBagDetail(bagDetailSelect.value);
          const selectedButton = buttons.find((button) => button.classList.contains('is-selected')) || buttons[0];
          if (selectedButton) selectVariant(selectedButton);
        });
      }
    });

    bindBundleSwitches();
    updateBundleVariant();

    const productForm = variantInput ? variantInput.closest('form') : null;
    if (productForm) {
      productForm.addEventListener(
        'submit',
        () => {
          updateBundleVariant();
          syncStickyProperties();
        },
        true
      );
    }
    if (stickyForm) {
      stickyForm.addEventListener(
        'submit',
        () => {
          updateBundleVariant();
          syncStickyProperties();
        },
        true
      );
    }

    initKitStory(root);
  }

  function initKitStory(root) {
    const story = root.matches && root.matches('[data-kit-pdp-story]') ? root : root.querySelector('[data-kit-pdp-story]');
    if (!story || story.dataset.kitPdpStoryReady === 'true') return;
    story.dataset.kitPdpStoryReady = 'true';

    const tabs = Array.from(story.querySelectorAll('[data-kit-pdp-story-tab]'));
    const slides = Array.from(story.querySelectorAll('[data-kit-pdp-story-slide]'));
    const prev = story.querySelector('[data-kit-pdp-story-prev]');
    const next = story.querySelector('[data-kit-pdp-story-next]');
    const stage = story.querySelector('.primavera-kit-pdp__story-stage');
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    function activate(index) {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;

      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive && window.matchMedia('(max-width: 749px)').matches) {
          window.requestAnimationFrame(() => {
            tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          });
        }
      });

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;
        if (isActive) {
          slide.querySelectorAll('img[loading="lazy"]').forEach((image) => {
            image.loading = 'eager';
          });
        }
      });
    }

    tabs.forEach((tab, index) => tab.addEventListener('click', () => activate(index)));
    if (prev) prev.addEventListener('click', () => activate(activeIndex - 1));
    if (next) next.addEventListener('click', () => activate(activeIndex + 1));

    if (stage) {
      let touchStartX = 0;
      let touchStartY = 0;

      stage.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      stage.addEventListener('touchend', (event) => {
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        activate(activeIndex + (deltaX < 0 ? 1 : -1));
      }, { passive: true });
    }

    activate(activeIndex);
  }

  function init(scope) {
    const parent = scope || document;
    parent.querySelectorAll('[data-primavera-kit-pdp]').forEach(initKitPdp);
    parent.querySelectorAll('[data-kit-pdp-story]').forEach(initKitStory);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

